import React, { useContext, useState } from 'react';
import { Form, message } from 'antd';
import { ContextStatus } from '@leedpulse-monorepo/enums';
import { FormCard } from '@leedpulse-monorepo/components';
import { IAdmin } from '@leedpulse-monorepo/interfaces';
import AuthenticationContext from '../../contexts/auth/AuthenticationContext';
import createAdmin from '../../../domain/use_cases/admins/createAdmin';
import AdminFormFields from './AdminFormFields';
import { EMPTY_ADMIN } from './AdminFormInitialValues';

interface AdminCreationFormProps {
  onCreated?: (id: string) => void | Promise<void>;
}

const AdminCreationForm: React.FC<AdminCreationFormProps> = ({ onCreated }) => {
  const authContext = useContext(AuthenticationContext);

  const [form] = Form.useForm<IAdmin>();
  const [status, setStatus] = useState<ContextStatus>(ContextStatus.IDLE);

  const handleSubmit = async (values: IAdmin) => {
    if (!authContext.authentication) {
      message.error('Vous devez être connecté pour effectuer cette action');
      return;
    }

    setStatus(ContextStatus.LOADING);

    try {
      const payload = {
        ...EMPTY_ADMIN,
        ...values,
      };

      await createAdmin(payload, authContext.authentication);
      message.success('Configuration créée avec succès');
      await onCreated?.(payload.id);
    } catch (error) {
      console.error(error);
      message.error('Erreur lors de la création de la configuration');
      setStatus(ContextStatus.ERROR);
      return;
    }

    setStatus(ContextStatus.SUCCESS);
  };

  return (
    <FormCard
      title="Nouvelle configuration"
      showTitle={false}
      onCreated={() => form.submit()}
      isCreateLoading={status === ContextStatus.LOADING}
    >
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        initialValues={EMPTY_ADMIN}
        onFinish={handleSubmit}
      >
        <AdminFormFields form={form} isCreateMode />
      </Form>
    </FormCard>
  );
};

export default AdminCreationForm;
